export enum Device {
  WEB = 1,
  MOBILE = 2,
  ANDROID = 3,
  IOS = 4,
}

export enum DeviceScreenWidth {
  MOBILE = 576,
  TABLET = 768,
  DESKTOP = 992,
}
